import React from 'react';
import { SpanProps } from '../../../../types/HtmlProps';
import { appendClassName } from '../../../../lib/bemUtils/classname';
import { SVG, SVGIcon } from '../../../../components/atoms/SVG';

type WidgetIconProps = {
  icon: SVGIcon;
};

export function WidgetIcon({ icon, className, ...spanProps }: WidgetIconProps & SpanProps) {
  return (
    <span className={appendClassName(className, 'widget-header__iconcontainer')} {...spanProps}>
      <SVG svgSpriteId={icon} />
    </span>
  );
}
